import { QueryKey } from "@tanstack/react-query";

export const memberAsPublicQueryKeys = {
  all: () => ["memberAsMember"] as QueryKey,
  emailExists: (email?: string) =>
    [...memberAsPublicQueryKeys.all(), "emailExists", email] as QueryKey,
};
